import React from 'react';
import Big from 'big.js';
import { useTranslation } from 'react-i18next';
import { useExchangeRate } from '../../../../../../hooks/exchangeRate';

export const Notice: React.FC = () => {
  const { t } = useTranslation('byCard');
  const { RUBUSD } = useExchangeRate();

  if (!RUBUSD) {
    return (
      <>{t('In the next step, after the replenishment, you can exchange rubles to dollars')}</>
    );
  }

  const rate = new Big(1).div(RUBUSD).round(2).valueOf();

  return (
    <>
      {t('In the next step, after the replenishment, you can exchange rubles at a rate')} {rate}
    </>
  );
};
